<template>
	<div class="col-full">
		<h1>Not Found</h1>
	</div>
</template>

<script>
	export default {};
</script>

<style></style>
